import React from 'react';
import { useLottie } from 'lottie-react';
import Alert from 'assets/animation/alert.json';
import styles from './AlertAnimation.module.scss';
const AlertAnimation = () => {
  const options = {
    animationData: Alert,
    loop: true,
    color: 'red',
  };

  const { View } = useLottie(options);

  return <div className={styles.animationContainer}>{View}</div>;
};

export default AlertAnimation;
